// src/queries/getLibraryCardQuery.js
import { gql } from "@apollo/client";

export const GET_LIBRARY_CARD_QUERY = gql`
  query GetLibraryCard($tenantId: String!, $entityType: String!, $entityId: String!) {
    getLibraryCard(input: { tenantId: $tenantId, entityType: $entityType, entityId: $entityId }) {
      tenantId
      entityType
      entityId
      payload
      createdAt
    }
  }
`;
